import { render } from "./CalendarLogs.vue?vue&type=template&id=59e49d36"
import script from "./CalendarLogs.vue?vue&type=script&lang=js"
export * from "./CalendarLogs.vue?vue&type=script&lang=js"
script.render = render

export default script